<odx-modal-header>
  <odx-area-header i18n="@@floorplan.menu.addToProductList.header">Produkt zur Produktliste hinzufügen</odx-area-header>
</odx-modal-header>
<odx-modal-content>
  <h5 class="odx-title-5">{{ title }}</h5>
  <form odxForm [formGroup]="quantityForm" class="quantity-form">
    <odx-form-field i18n-label="@@global.quantity" label="Menge">
      <div odxLayout="flex" class="custom-spinbox">
        <button
          type="button"
          data-icon-set="core"
          data-icon-name="minus"
          class="odx-spinbox__action odx-icon"
          (click)="decrement()"
        ></button>
        <input class="odx-spinbox__input" odxFormFieldControl type="number" formControlName="quantity" />
        <button
          type="button"
          data-icon-set="core"
          data-icon-name="plus"
          class="odx-spinbox__action odx-icon"
          (click)="increment()"
        ></button>
      </div>
    </odx-form-field>
  </form>

  <div class="table-scroll-wrapper">
    <table class="navinta-table">
      <thead>
        <tr>
          <th i18n="@@productList.productTable.column2.header">Anzahl</th>
          <th i18n="@@productList.productTable.column3.header">Bezeichnung</th>
          <th i18n="@@productList.productTable.column4.header">Sachnummer</th>
        </tr>
      </thead>
      <tbody>
        @for (row of previewRows(); track row.name + row.partNumber) {
          <tr>
            <td>{{ row.quantity }}</td>
            <td>{{ row.name }}</td>
            <td>{{ row.partNumber }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</odx-modal-content>
<odx-modal-footer>
  <button odxButton variant="secondary" odxModalDismiss class="add-config-dismiss-button" i18n="@@global.dismiss">
    Abbrechen
  </button>
  <button
    odxButton
    variant="primary"
    (click)="confirm()"
    class="add-config-confirm-button"
    [disabled]="quantityForm.invalid"
    i18n="@@global.confirm"
  >
    Bestätigen
  </button>
</odx-modal-footer>
